function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React, { Fragment, memo } from "react";
import { mix } from "polished";
import styled, { css } from "styled-components";
import OnColorContext from "../../../../contexts/OnColorContext";
import { pageGutterSpace } from "../../../../settings";
import breakpoint from "../../../../utils/breakpoint";
import getColor from "../../../../utils/getColor";
import isNotEmpty from "../../../../utils/isNotEmpty";
import space from "../../../../utils/space";
import unit from "../../../../utils/unit";
import DividerAtm from "../../../atoms/DividerAtm";
import ExpandableContentOrg from "../../../organisms/ExpandableContentOrg";
import { biggerScreenBreakpoint, biggerScreenLastRowStyles, borderWidthOnBiggerScreen, Cell, cellBackground, Label, tableBackgroundOnMobile } from "../common";
import RowLabel from "./RowLabel";
import Value from "./Value";
var contentLastRowStyles = function contentLastRowStyles(activeColumnIndex, tableHasFooter) {
  var style = css([""]);
  if (!tableHasFooter) {
    style = biggerScreenLastRowStyles(activeColumnIndex);
  }
  return style;
};
var StyledContent = styled.div.withConfig({
  componentId: "sc-163trqb-0"
})(function (_ref) {
  var $activeColumnIndex = _ref.$activeColumnIndex,
    $tableHasFooter = _ref.$tableHasFooter;
  return css(["padding:", " ", ";", "{padding:0;", "}"], space(2), space(pageGutterSpace), breakpoint(biggerScreenBreakpoint), contentLastRowStyles($activeColumnIndex, $tableHasFooter));
});
var GroupLabelWrapper = styled.div.withConfig({
  componentId: "sc-163trqb-1"
})(["display:flex;margin:", " 0;> div{grid-column:1 / -1;align-items:center;justify-content:center;width:100%;", "{justify-content:start;padding-left:", ";}}", "{align-items:center;min-height:", ";margin:0 0 ", ";background:", ";> div{grid-column:auto;}}"], space(4), breakpoint(biggerScreenBreakpoint), space(4), breakpoint(biggerScreenBreakpoint), space(10), unit(borderWidthOnBiggerScreen), function (props) {
  return getColor(props.theme, "background");
});
var Row = styled.div.withConfig({
  componentId: "sc-163trqb-2"
})(function (_ref2) {
  var $isHighlighted = _ref2.$isHighlighted,
    $numberOfColumns = _ref2.$numberOfColumns,
    theme = _ref2.theme;
  return css(["display:flex;grid-column-gap:", ";grid-template-columns:repeat(", ",1fr);flex-wrap:wrap;width:100%;margin-bottom:", ";&:last-child{margin-bottom:0;}", " ", "{> div:first-child{flex-flow:row;min-width:", ";}grid-column-gap:", ";grid-template-columns:", ";min-height:", ";margin-bottom:", ";&:hover{> div{background:", ";}}}"], unit(4), $numberOfColumns, space(2), $isHighlighted && css(["> div{&:first-child{background-color:", ";border:0;}border:1px solid ", ";}", "{> div{background-color:", " !important;border:0;}}"], getColor(theme, "background"), getColor(theme, "success"), breakpoint(biggerScreenBreakpoint), getColor(theme, "successLight")), breakpoint(biggerScreenBreakpoint), space(50), unit(borderWidthOnBiggerScreen), $numberOfColumns === 1 ? "1fr 1fr" : "".concat(space(50), " repeat(").concat($numberOfColumns, ", 1fr)"), space(8), unit(borderWidthOnBiggerScreen), mix(0.55, getColor(theme, "background"), getColor(theme, cellBackground)));
});

/* eslint-disable react/no-array-index-key */
function Content(_ref3) {
  var groups = _ref3.groups,
    activeColumnIndex = _ref3.activeColumnIndex,
    isBiggerScreen = _ref3.isBiggerScreen,
    showMoreDetails = _ref3.showMoreDetails,
    tableHasFooter = _ref3.tableHasFooter,
    numberOfColumns = _ref3.numberOfColumns;
  var tableMolRowLabelOnColor = isBiggerScreen ? cellBackground : tableBackgroundOnMobile;
  return /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: tableBackgroundOnMobile
  }, /*#__PURE__*/React.createElement(ExpandableContentOrg, {
    showMoreDetails: showMoreDetails,
    breakpoint: {
      from: "small",
      to: biggerScreenBreakpoint
    }
  }, /*#__PURE__*/React.createElement(StyledContent, {
    $activeColumnIndex: activeColumnIndex,
    $tableHasFooter: tableHasFooter
  }, groups.map(function (_ref4, groupIndex) {
    var groupLabel = _ref4.groupLabel,
      rows = _ref4.rows;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: "Group-".concat(groupIndex)
    }, groupLabel ? /*#__PURE__*/React.createElement(GroupLabelWrapper, null, /*#__PURE__*/React.createElement("div", null, !isBiggerScreen ? /*#__PURE__*/React.createElement(DividerAtm, null, groupLabel) : null, isBiggerScreen ? /*#__PURE__*/React.createElement(Label, null, groupLabel) : null)) : null, rows.map(function (_ref5, rowIndex) {
      var label = _ref5.label,
        values = _ref5.values,
        isHighlighted = _ref5.isHighlighted,
        dataTestId = _ref5.dataTestId;
      if (!isNotEmpty(values)) {
        return null;
      }
      return /*#__PURE__*/React.createElement(Row, {
        $isHighlighted: isHighlighted,
        $numberOfColumns: numberOfColumns,
        key: "Row-".concat(groupIndex, "-").concat(rowIndex)
      }, /*#__PURE__*/React.createElement(RowLabel, {
        label: label,
        onColor: tableMolRowLabelOnColor,
        isHighlighted: isHighlighted
      }), values.map(function (value, cellIndex) {
        return /*#__PURE__*/React.createElement(Cell, {
          "data-test-id": dataTestId,
          key: "Cell-".concat(groupIndex, "-").concat(rowIndex, "-").concat(cellIndex),
          $align: value && _typeof(value) === "object" && "align" in value ? value.align : undefined
        }, /*#__PURE__*/React.createElement(Value, {
          value: value,
          onColor: cellBackground
        }));
      }));
    }));
  }))));
}
export default /*#__PURE__*/memo(Content);